import {Component, inject, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfirmationService } from 'primeng/api';
import { TranslateModule } from '@ngx-translate/core';
import { CargosPermisoComponent } from './cargos-permiso/cargos-permiso.component';
import { TabViewModule } from 'primeng/tabview';
import { PermisosComponent } from './permisos/permisos.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-admin-cargos',
  standalone: true,
  imports: [
    CommonModule, TranslateModule, CargosPermisoComponent, TabViewModule, PermisosComponent
  ],
  providers: [ConfirmationService],
  template:`
  <section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
            <p-tabPanel [header]="'app-menu.cargos' | translate">
                <app-cargos-permiso></app-cargos-permiso>
            </p-tabPanel>
            <p-tabPanel [header]="'common.permisos' | translate">
                <app-permisos></app-permisos>
            </p-tabPanel>
        </p-tabView>
    </div>
  </section>
  `,
  styleUrls: ['../../../../assets/styles/style.mantenimiento.scss']
})
export class AdminCargosComponent {
  activeTabIndex: number = 0;

  @ViewChild(CargosPermisoComponent) cargosPermisoComponent !: CargosPermisoComponent;
  @ViewChild(PermisosComponent) permisosComponent !: PermisosComponent;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor() {
  }

  activeIndexChange(index: number) {
    if (index === 0){
      this.cargosPermisoComponent.getCargos();
      this.titleService.changeTitle('app-menu.cargos');
    } else {
      this.permisosComponent.getPermisos();
      this.titleService.changeTitle('common.permisos');
    }
  }
}
